"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MISSING_ALT_TEXT_TEST_FLAG = exports.MEDIA_WIDTH = exports.MEDIA_HEIGHT = exports.LABEL_WARNING_COLOR = exports.LABEL_SPACING = exports.LABEL_SIZE = exports.LABEL_ERROR_COLOR = exports.LABEL_COLOR = exports.LABEL_ASTERISK_SPACING = exports.LABEL_ASTERISK_COLOR = exports.EventKeys = exports.EventKeyCodes = exports.EM_TO_PX_RATIO = exports.DEFAULT_S_ICON_SIZE = exports.DEFAULT_LINE_HEIGHT = exports.DEFAULT_ICON_SIZE = exports.BORDER_SCALE = exports.A11Y_SIZE = exports.A11Y_MIN_SIZE = exports.A11Y_INLINE_MIN_SIZE = void 0;
var EventKeys = {
  SPACEBAR: ' ',
  ENTER: 'Enter',
  ESCAPE: 'Escape',
  ARROW_UP: 'ArrowUp',
  ARROW_DOWN: 'ArrowDown',
  ARROW_LEFT: 'ArrowLeft',
  ARROW_RIGHT: 'ArrowRight',
  BACKSPACE: 'Backspace',
  DELETE: 'Delete',
  PAGE_UP: 'PageUp',
  PAGE_DOWN: 'PageDown',
  TAB: 'Tab',
  SHIFT: 'Shift',
  HOME: 'Home',
  END: 'End',
  F10: 'F10'
};
exports.EventKeys = EventKeys;
var EventKeyCodes = {
  SPACEBAR: 32,
  ENTER: 13,
  ESCAPE: 27,
  ARROW_UP: 38,
  ARROW_DOWN: 40,
  ARROW_LEFT: 37,
  ARROW_RIGHT: 39,
  BACKSPACE: 8,
  DELETE: 46,
  PAGE_UP: 33,
  PAGE_DOWN: 34,
  TAB: 9,
  HOME: 36,
  END: 35,
  F10: 121,
  K: 75,
  DIGITS: [48, 49, 50, 51, 52, 53, 54, 55, 56, 57]
};
exports.EventKeyCodes = EventKeyCodes;
var EM_TO_PX_RATIO = 16;
exports.EM_TO_PX_RATIO = EM_TO_PX_RATIO;
var BORDER_SCALE = 1.3; // Minimum accessible touch target sizes

exports.BORDER_SCALE = BORDER_SCALE;
var A11Y_SIZE = 44;
exports.A11Y_SIZE = A11Y_SIZE;
var A11Y_MIN_SIZE = 36;
exports.A11Y_MIN_SIZE = A11Y_MIN_SIZE;
var A11Y_INLINE_MIN_SIZE = 24; // Default sizes

exports.A11Y_INLINE_MIN_SIZE = A11Y_INLINE_MIN_SIZE;
var DEFAULT_LINE_HEIGHT = 1;
exports.DEFAULT_LINE_HEIGHT = DEFAULT_LINE_HEIGHT;
var DEFAULT_ICON_SIZE = 20;
exports.DEFAULT_ICON_SIZE = DEFAULT_ICON_SIZE;
var DEFAULT_S_ICON_SIZE = 16; // Constants for form elements

exports.DEFAULT_S_ICON_SIZE = DEFAULT_S_ICON_SIZE;
var LABEL_SIZE = 'T200';
exports.LABEL_SIZE = LABEL_SIZE;
var LABEL_COLOR = 'neutral90';
exports.LABEL_COLOR = LABEL_COLOR;
var LABEL_SPACING = 'S200';
exports.LABEL_SPACING = LABEL_SPACING;
var LABEL_ASTERISK_SPACING = 'S100';
exports.LABEL_ASTERISK_SPACING = LABEL_ASTERISK_SPACING;
var LABEL_ASTERISK_COLOR = 'neutral70';
exports.LABEL_ASTERISK_COLOR = LABEL_ASTERISK_COLOR;
var LABEL_ERROR_COLOR = 'red70';
exports.LABEL_ERROR_COLOR = LABEL_ERROR_COLOR;
var LABEL_WARNING_COLOR = 'yellow70'; // A11y

exports.LABEL_WARNING_COLOR = LABEL_WARNING_COLOR;
var MISSING_ALT_TEXT_TEST_FLAG = 'accessibility-missing-alt-text'; // Must have 16:9 ratio due to video content

exports.MISSING_ALT_TEXT_TEST_FLAG = MISSING_ALT_TEXT_TEST_FLAG;
var MEDIA_WIDTH = 544;
exports.MEDIA_WIDTH = MEDIA_WIDTH;
var MEDIA_HEIGHT = 306;
exports.MEDIA_HEIGHT = MEDIA_HEIGHT;